import React from "react";

function Coin({ width, height }) {
  return (
    <div>
      <svg
        width={`${width}`}
        height={`${height}`}
        viewBox="0 0 13 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.5 13.5C10.0899 13.5 13 10.5899 13 7C13 3.41015 10.0899 0.5 6.5 0.5C2.91015 0.5 0 3.41015 0 7C0 10.5899 2.91015 13.5 6.5 13.5Z"
          fill="#F9C65B"
        />
        <path
          d="M11.2775 2.59219C10.0786 1.48186 8.50379 0.866463 6.86969 0.869687C3.28047 0.869687 0.369687 3.78047 0.369687 7.36969C0.369687 9.06984 1.02375 10.6177 2.09219 11.7775C0.806406 10.5892 0 8.88906 0 7C0 3.41078 2.91078 0.5 6.5 0.5C8.38906 0.5 10.0892 1.30641 11.2775 2.59219Z"
          fill="#FFE27B"
        />
        <path
          d="M12.9998 7.00009C12.9998 10.5893 10.0891 13.5001 6.49984 13.5001C4.61484 13.5001 2.91672 12.6977 1.73047 11.416C2.93066 12.5305 4.50855 13.1489 6.14641 13.1466C9.73562 13.1466 12.6464 10.2359 12.6464 6.64665C12.6464 4.94243 11.9903 3.39056 10.9158 2.23071C12.1975 3.41696 12.9998 5.11509 12.9998 7.00009Z"
          fill="#F6B444"
        />
        <path
          d="M6.50086 12.3545C9.458 12.3545 11.8552 9.95727 11.8552 7.00013C11.8552 4.04299 9.458 1.64575 6.50086 1.64575C3.54372 1.64575 1.14648 4.04299 1.14648 7.00013C1.14648 9.95727 3.54372 12.3545 6.50086 12.3545Z"
          fill="#F6B444"
        />
        <path
          d="M10.4902 3.42919C9.50954 2.54848 8.2374 2.06221 6.9193 2.06419C3.9618 2.06216 1.56289 4.46106 1.56289 7.41856C1.56289 8.79169 2.07883 10.0429 2.92789 10.9895C1.83508 10.0084 1.14648 8.5845 1.14648 7.00013C1.14648 4.04263 3.54336 1.64575 6.50086 1.64575C8.08523 1.64575 9.51117 2.33435 10.4902 3.42919Z"
          fill="#F09922"
        />
        <path
          d="M8.07034 10.7887C10.1629 9.92192 11.1566 7.52291 10.2898 5.43035C9.42306 3.33779 7.02405 2.34409 4.93149 3.21085C2.83893 4.07762 1.84523 6.47663 2.712 8.56919C3.57877 10.6617 5.97777 11.6555 8.07034 10.7887Z"
          fill="#FFCA5C"
        />
        <path
          d="M10.9695 7.36771C10.9695 9.63255 9.1332 11.4688 6.86836 11.4688C5.64148 11.4688 4.54258 10.9305 3.79102 10.0774C4.51414 10.7152 5.46273 11.1011 6.50273 11.1011C8.76758 11.1011 10.6038 9.26489 10.6038 7.00005C10.6038 5.96005 10.2179 5.01146 9.58008 4.28833C10.4312 5.03989 10.9695 6.14083 10.9695 7.36771Z"
          fill="#F09922"
        />
        <path
          d="M7.94253 5.11877V4.37304L5.23438 4.37304V5.11877H5.62725C5.83476 5.14424 6.00031 5.20446 6.11922 5.30018C6.20898 5.37198 6.2731 5.47079 6.31391 5.59353H5.23438V6.33926H6.30458C6.26727 6.44734 6.21131 6.53766 6.13787 6.61099C5.98748 6.75998 5.74266 6.83487 5.40691 6.83487H5.23438L5.23438 7.55203H5.61792L6.6753 9.66724H7.49719L6.24979 7.32353C6.69046 7.10814 6.96092 6.77928 7.06235 6.33849H7.94369V5.59276L7.088 5.59276C7.06468 5.41521 7.02038 5.25695 6.95626 5.118L7.94369 5.118L7.94253 5.11877Z"
          fill="#FFB700"
        />
        <path
          d="M7.8019 5.11873V4.373L5.09375 4.373V5.11873H5.48662C5.69414 5.14421 5.85968 5.20442 5.97859 5.30014C6.06836 5.37194 6.13248 5.47075 6.17328 5.59349H5.09375V6.33922H6.16395C6.12665 6.4473 6.07069 6.53762 5.99724 6.61095C5.84686 6.75995 5.60204 6.83483 5.26629 6.83483H5.09375L5.09375 7.55199H5.4773L6.53468 9.66797H7.35657L6.10916 7.32426C6.54983 7.10888 6.8203 6.78002 6.92172 6.33922H7.80307V5.59349L6.94737 5.59349C6.92405 5.41594 6.87975 5.25769 6.81564 5.11873L7.80307 5.11873H7.8019Z"
          fill="#FFEF61"
        />
        <path
          d="M7.70034 5.11873V4.373L4.99219 4.373V5.11873H5.38506C5.59257 5.14421 5.75812 5.20442 5.87703 5.30014C5.9668 5.37194 6.03091 5.47075 6.07172 5.59349H4.99219V6.33922H6.06239C6.02509 6.4473 5.96913 6.53762 5.89568 6.61095C5.74529 6.75995 5.50048 6.83483 5.16473 6.83483H4.99219L4.99219 7.55199H5.37574L6.43312 9.66797H7.255L6.0076 7.32426C6.44827 7.10888 6.71874 6.78002 6.82016 6.33922H7.70151V5.59349L6.84581 5.59349C6.82249 5.41594 6.77819 5.25769 6.71407 5.11873L7.70151 5.11873H7.70034Z"
          fill="#FFB800"
        />
        <defs>
          <clipPath id="clip0_12397_12902">
            <rect
              width="11"
              height="11"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

export default Coin;
